/*
  Size availability path — see snippets/size-availability-path.liquid.

  Links render server-side and are correct on their own. This only appends live
  counts ("XL 43") fetched from the filtered collection.

  Two things learned the hard way, both recorded so they are not repeated:
  - The line cannot be revealed by tapping a sold-out pill. The theme sets
    pointer-events:none on labels for unavailable variants, so a real tap never
    fires. Dispatching events programmatically bypasses that and gives a false
    pass.
  - The picker renders more than once per page, so this file executes more than
    once. Booting is guarded globally, and each root is marked via
    data-counts so its state is inspectable from the console.
*/
(function () {
	if (window.__sempurnaSizePathBooted) return;
	window.__sempurnaSizePathBooted = true;

	function loadCounts(root) {
		if (root.dataset.counts) return;
		root.dataset.counts = 'pending';

		var collection = root.dataset.collection;
		var links = root.querySelectorAll('[data-size-path-size]');
		var pending = links.length;
		if (!pending) {
			root.dataset.counts = 'none';
			return;
		}

		Array.prototype.forEach.call(links, function (link) {
			var size = link.dataset.sizePathSize;
			var slot = link.querySelector('[data-size-path-count]');
			var url =
				collection +
				'?sort_by=created-descending&filter.v.availability=1&filter.v.option.size=' +
				encodeURIComponent(size);

			fetch(url)
				.then(function (r) { return r.text(); })
				.then(function (html) {
					var m = html.match(/Showing\s+(\d+)/i);
					if (m && slot) slot.textContent = ' (' + m[1] + ')';
				})
				.catch(function () { /* the link alone is still correct */ })
				.then(function () {
					pending -= 1;
					if (pending <= 0) root.dataset.counts = 'done';
				});
		});
	}

	function boot() {
		var roots = document.querySelectorAll('[data-size-path]');
		Array.prototype.forEach.call(roots, loadCounts);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();
